module.exports = "/images/johan-dehen.jpg?6f6944892961b2147f1897800b4cfe8c";